<script lang="ts" setup>
import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { UserCircleIcon } from 'tir-style-system/icons/outline';
import { TirPmIconView } from 'tir-components';

/**Параметры */
const props = defineProps({
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
});

/**Показанные наблюдатели */
const shownPersons = computed(() => {
  const persons = props.task.Observers.slice(0, 2);
  const uniqueIds = Array.from(new Set(persons.map((p) => p.Id)));
  const personsToShow = [];
  uniqueIds.forEach((id) => {
    personsToShow.push(persons.find((p) => p.Id == id));
  });
  return personsToShow;
});
/**Скрытые наблюдатели */
const hiddenPersons = computed(() =>
  Math.max(props.task.Observers.length - shownPersons.value.length, 0),
);
</script>
<template>
  <TaskCardItemWrapper :element="element">
    <template v-if="shownPersons">
      <TirPmIconView
        v-for="person in shownPersons"
        is-rounded
        :size="24"
        :imageLoadUrl="person.ImageUrl"
        :colorCode="person.NoPhotoColor"
        :is-bordered="false"
      >
        <template #mainSlot>
          {{ person.FirstName[0] + person.LastName[0] }}
        </template>
      </TirPmIconView>
      <div v-if="hiddenPersons" v-text="`+${hiddenPersons}`" />
    </template>
  </TaskCardItemWrapper>
</template>
<style lang="scss" scoped></style>
